const config = {
  apiBase: "https://saenablement.sbattoo.people.aws.dev/api",
  chatStreamUrl: "https://saenablement.sbattoo.people.aws.dev/api/chat-stream",
  cognito: {
    userPoolId: "us-west-2_PXBKWI9ot",
    clientId: "7mvot9ng6ng2oqe23ejmbm7as1",
    region: "us-west-2"
  }
};
export default config;
